import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { FREE_TOOL_KEYS, getGuide, guideNavPath } from "@/lib/guides";
import { localePath, makeTr, pick, type LandingLocale } from "@/lib/landing/locale";
import { Container } from "./primitives";

const linkClass =
  "inline-flex items-center gap-1 font-medium text-foreground underline-offset-4 hover:underline";

/**
 * A slim line about the free browser-only tools, inside the closing block
 * between the final ask and the footer. It is not a section of its own, so the
 * page's band and contour rhythm stays as it is.
 */
export function ToolsStrip({ locale }: { locale: LandingLocale }) {
  const tr = makeTr(locale);
  return (
    <aside aria-label={tr("Nástroje zdarma", "Free tools")}>
      <Container className="pb-10">
        <div className="flex flex-col gap-3 rounded-xl border bg-card/70 px-5 py-4 text-sm sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-start gap-2 text-muted-foreground">
            <ShieldCheck
              aria-hidden="true"
              className="mt-0.5 size-4 shrink-0 text-[hsl(var(--action))] dark:text-primary"
            />
            <span>
              <span className="font-medium text-foreground">
                {tr("Nástroje zdarma", "Free tools")}
              </span>
              {tr(
                " běží jen ve vašem prohlížeči, bez registrace: ",
                " run only in your browser, no sign-up: "
              )}
              {FREE_TOOL_KEYS.map((key, i) => (
                <span key={key}>
                  {i > 0 && ", "}
                  <Link to={localePath(locale, guideNavPath(key))} className={linkClass}>
                    {pick(getGuide(key).name, locale)}
                  </Link>
                </span>
              ))}
            </span>
          </p>
          <Link
            to={localePath(locale, guideNavPath("tools"))}
            className={`${linkClass} shrink-0 text-[hsl(var(--action))] dark:text-primary`}
          >
            {tr("Všechny nástroje", "All tools")}
            <ArrowRight aria-hidden="true" className="size-3.5" />
          </Link>
        </div>
      </Container>
    </aside>
  );
}
